import MdaePopup from "./component";
import { MdaePopupTitle } from "./popup-title";
import { MdaePopupFooter } from "./popup-footer";
import { MdaePopupContent } from "./popup-content";
import { MdaePopupFooterStartButtons } from "./popup-footer-start-buttons";
import { MdaePopupFooterEndButtons } from "./popup-footer-end-buttons";
import { IPopupOptions } from "devextreme-react/popup";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";

export interface IMdaePopupProps extends IPopupOptions {
  mdaeTitleRender?: any;
  mdaeContentRender?: any;
  mdaeFooterRender?: any;
  mdaeFooterRenderComponent?: React.ReactNode;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  autoHeight?: boolean;
  mdaeContentRenderComponent?:React.ReactNode;
}
export interface IMdaePopupTitleProps {
  closePopupHandler: any;
  isHideCloseButton?: boolean;
  isSmallPopup?: boolean;
  customTitleRender?: any;
  className?: string;
  style?: any;
  children?: React.ReactNode;
}
export interface IMdaePopupContentProps {
  className?: string;
  children?: React.ReactNode;
}
export interface IMdaePopupFooterProps {
  isHideTopBorder?: boolean;
  children?: React.ReactNode;
}
export interface IMdaePopupFooterStartButtons {
  children?: React.ReactNode;
}
export interface IMdaePopupFooterEndButtons {
  id?: string
  style?: any
  children?: React.ReactNode;
}

export default MdaePopup;
export {
  MdaePopupTitle,
  MdaePopupFooter,
  MdaePopupContent,
  MdaePopupFooterStartButtons,
  MdaePopupFooterEndButtons,
};
